import classNames from 'classnames'
import { Button, Modal } from 'react-bootstrap'
import { useIsMobile } from '../../hooks/useMediaQuery'

export type PianificazioneStep = 'selezione' | 'dettagli'

// Su mobile la modale di pianificazione mostra una sezione alla volta (lista oppure
// operatore/calendario/note): queste schede permettono di passare dall'una all'altra in ogni momento
export function PianificazioneTabs({
  step,
  setStep,
  labelSelezione,
  selectedCount,
}: {
  step: PianificazioneStep
  setStep: (step: PianificazioneStep) => void
  labelSelezione: string
  selectedCount: number
}) {
  const isMobile = useIsMobile()
  if (!isMobile) return null

  const tab = (value: PianificazioneStep, label: string) => (
    <button
      type="button"
      className={classNames('btn', step === value ? 'btn-secondary text-white' : 'btn-outline-secondary')}
      onClick={() => setStep(value)}
    >
      {label}
    </button>
  )

  return (
    <div className="btn-group w-100 mb-3 pianificazione-tabs" role="tablist">
      {tab('selezione', `${labelSelezione} (${selectedCount})`)}
      {tab('dettagli', 'Data e operatore')}
    </div>
  )
}

// Footer: su mobile guida in due passaggi (selezione -> "Avanti" -> data e operatore -> "Salva"),
// le schede in cima restano disponibili per saltare da una sezione all'altra
export default function PianificazioneFooter({
  step,
  setStep,
  selectedCount,
  canSave,
  onClose,
  onSave,
}: {
  step: PianificazioneStep
  setStep: (step: PianificazioneStep) => void
  selectedCount: number
  canSave: boolean
  onClose: () => void
  onSave: () => void
}) {
  const isMobile = useIsMobile()

  if (!isMobile) {
    return (
      <Modal.Footer className="d-flex justify-content-end">
        <Button type="button" onClick={onClose} variant="outline-secondary">
          Chiudi
        </Button>
        <Button type="button" variant="secondary" disabled={!canSave} className="text-white" onClick={onSave}>
          Salva
        </Button>
      </Modal.Footer>
    )
  }

  if (step === 'selezione') {
    return (
      <Modal.Footer className="d-flex flex-nowrap">
        <Button type="button" onClick={onClose} variant="outline-secondary" className="flex-fill">
          Chiudi
        </Button>
        <Button
          type="button"
          variant="secondary"
          className="text-white flex-fill"
          disabled={selectedCount === 0}
          onClick={() => setStep('dettagli')}
        >
          Avanti ({selectedCount})
        </Button>
      </Modal.Footer>
    )
  }

  return (
    <Modal.Footer className="d-flex flex-nowrap">
      <Button type="button" onClick={() => setStep('selezione')} variant="outline-secondary" className="flex-fill">
        Indietro
      </Button>
      <Button type="button" variant="secondary" disabled={!canSave} className="text-white flex-fill" onClick={onSave}>
        Salva
      </Button>
    </Modal.Footer>
  )
}
